<template>
	<div class="container">
		<div
			ref="sidebar"
			:class="['content_menu', { active: isContentMenuActive }]"
		>
			<tnc-sidebar
				@sidebarClick="handleSidebarClick"
				:items="menu_items"
			></tnc-sidebar>
			<div :class="['menu_btn']" @click="menuHandler">
				<span></span>
			</div>
		</div>
		<div class="content_inner">
			<div class="content" ref="content">
				<h1 class="content_title" id="scrollpoint1">
					{{ $t('terms.title') }}
				</h1>
				<router-view></router-view>
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text1') }}<br /><br />-->
				<!--					{{ $t('rtr_privacy.text2') }}<br />-->
				<!--					{{ $t('rtr_privacy.text3') }}-->
				<!--					{{ $t('rtr_privacy.text4') }}-->
				<!--					{{ $t('rtr_privacy.text4_1') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link1') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text5') }}-->
				<!--					{{ $t('rtr_privacy.text6') }}-->
				<!--					{{ $t('rtr_privacy.text7') }}-->
				<!--					{{ $t('rtr_privacy.text8') }}-->
				<!--					{{ $t('rtr_privacy.text9') }}-->
				<!--					{{ $t('rtr_privacy.text10') }}-->
				<!--					{{ $t('rtr_privacy.link2') }}-->
				<!--					{{ $t('rtr_privacy.text10_1') }}-->
				<!--				</p>-->
				<!--				<ul class="link_list">-->
				<!--					<li>-->
				<!--						<router-link to="">{{ $t('rtr_privacy.list1') }}</router-link>-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						<router-link to="">{{ $t('rtr_privacy.list2') }}</router-link>-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						<router-link to="">{{ $t('rtr_privacy.list3') }}</router-link>-->
				<!--					</li>-->
				<!--				</ul>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text11') }}-->
				<!--					{{ $t('rtr_privacy.text12') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link2') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text13') }}-->
				<!--					{{ $t('rtr_privacy.text14') }}-->
				<!--					{{ $t('rtr_privacy.text15') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link3') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text16') }}-->
				<!--					{{ $t('rtr_privacy.text17') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link2') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text18') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link3') }}</router-link-->
				<!--					>{{ $t('rtr_privacy.text19') }}-->
				<!--					{{ $t('rtr_privacy.text20') }}-->
				<!--					{{ $t('rtr_privacy.text21') }}-->
				<!--					{{ $t('rtr_privacy.text22') }}-->
				<!--				</p>-->

				<!--				<h2 id="scrollpoint2">{{ $t('rtr_privacy.title2') }}</h2>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text23') }}-->
				<!--					{{ $t('rtr_privacy.text24') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link1') }}</router-link-->
				<!--					>{{ $t('rtr_privacy.text25') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title3') }}</h3>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text26') }}-->
				<!--					{{ $t('rtr_privacy.text27') }}-->
				<!--					{{ $t('rtr_privacy.text28') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title4') }}</h3>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text29') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link1') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text30') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text31') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link1') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text32') }}-->
				<!--				</p>-->

				<!--				<h3 id="scrollpoint3">{{ $t('rtr_privacy.title5') }}</h3>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text33') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link5') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text34') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text35') }}-->
				<!--				</p>-->

				<!--				<ul>-->
				<!--					<li>{{ $t('rtr_privacy.list4') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list5') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list6') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list7') }}</li>-->
				<!--				</ul>-->

				<!--				<h3>{{ $t('rtr_privacy.title6') }}</h3>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text36') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title7') }}</h3>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text37') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text38') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text39') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link1') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text40') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title8') }}</h3>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text41') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text42') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link6') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text43') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link7') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text44') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link8') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text45') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text46') }}-->
				<!--				</p>-->

				<!--				<p>{{ $t('rtr_privacy.text47') }}</p>-->

				<!--				<h2 id="scrollpoint4">{{ $t('rtr_privacy.title9') }}</h2>-->

				<!--				<h3>{{ $t('rtr_privacy.title10') }}</h3>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text48') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title11') }}</h3>-->

				<!--				<ul>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list8') }}-->
				<!--						<router-link to="">{{ $t('rtr_privacy.link9') }}</router-link>-->
				<!--						{{ $t('rtr_privacy.list9') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list10') }}-->
				<!--						<router-link to="">{{ $t('rtr_privacy.link10') }}</router-link>-->
				<!--						{{ $t('rtr_privacy.list11') }}-->
				<!--					</li>-->
				<!--				</ul>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text49') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link11') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text50') }}-->
				<!--				</p>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text51') }}-->
				<!--				</p>-->

				<!--				<h3 id="scrollpoint5">{{ $t('rtr_privacy.title12') }}</h3>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text52') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link14') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text53') }}-->
				<!--				</p>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text54') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link12') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text55') }}-->
				<!--					<router-link to="">{{ $t('rtr_privacy.link11') }}</router-link>-->
				<!--					{{ $t('rtr_privacy.text56') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title13') }}</h3>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text57') }}-->
				<!--				</p>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text58') }}-->
				<!--				</p>-->

				<!--				<h2 id="scrollpoint6">{{ $t('rtr_privacy.title14') }}</h2>-->

				<!--				<h3>{{ $t('rtr_privacy.title15') }}</h3>-->
				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text59') }}-->
				<!--				</p>-->
				<!--				<ul>-->
				<!--					<li>{{ $t('rtr_privacy.list12') }}</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list13') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list14') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list15') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list16') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list17') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list18') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list19') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list20') }}-->
				<!--						<router-link to="">https://www.JPWORLDPAY.com</router-link>-->
				<!--						{{ $t('rtr_privacy.list21') }}-->
				<!--					</li>-->
				<!--				</ul>-->

				<!--				<h3>{{ $t('rtr_privacy.title16') }}</h3>-->

				<!--				<p>-->
				<!--					{{ $t('rtr_privacy.text60') }}-->
				<!--				</p>-->

				<!--				<h3>{{ $t('rtr_privacy.title17') }}</h3>-->

				<!--				<ul>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list22') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list23') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list24') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list25') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list26') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list27') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list28') }}-->
				<!--						<ul>-->
				<!--							<li>{{ $t('rtr_privacy.list29') }}</li>-->
				<!--							<li>{{ $t('rtr_privacy.list30') }}</li>-->
				<!--							<li>-->
				<!--								{{ $t('rtr_privacy.list31') }}-->
				<!--							</li>-->
				<!--							<li>{{ $t('rtr_privacy.list32') }}</li>-->
				<!--							<li>{{ $t('rtr_privacy.list33') }}</li>-->
				<!--							<li>-->
				<!--								{{ $t('rtr_privacy.list34') }}-->
				<!--							</li>-->
				<!--							<li>-->
				<!--								{{ $t('rtr_privacy.list35') }}-->
				<!--							</li>-->
				<!--							<li>-->
				<!--								{{ $t('rtr_privacy.list36') }}-->
				<!--								<router-link to="">{{ $t('rtr_privacy.link13') }}</router-link>-->
				<!--								{{ $t('rtr_privacy.list37') }}-->
				<!--							</li>-->
				<!--							<li>-->
				<!--								{{ $t('rtr_privacy.list38') }}-->
				<!--								<router-link to="">https://www.JPWORLDPAY.com</router-link>-->
				<!--								{{ $t('rtr_privacy.list39') }}-->
				<!--							</li>-->
				<!--						</ul>-->
				<!--					</li>-->
				<!--				</ul>-->

				<!--				<h3>{{ $t('rtr_privacy.title18') }}</h3>-->
				<!--				<ul>-->
				<!--					<li>{{ $t('rtr_privacy.list40') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list41') }}</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list42') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list43') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list44') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list45') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list46') }}-->
				<!--					</li>-->
				<!--					<li>{{ $t('rtr_privacy.list47') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list48') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list49') }}</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list50') }}-->
				<!--					</li>-->
				<!--					<li>{{ $t('rtr_privacy.list51') }}</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list52') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list53') }}-->
				<!--					</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list54') }}-->
				<!--					</li>-->
				<!--				</ul>-->

				<!--				<h3>{{ $t('rtr_privacy.title19') }}</h3>-->

				<!--				<ul>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list55') }}-->
				<!--						<ul>-->
				<!--							<li>{{ $t('rtr_privacy.list56') }}</li>-->
				<!--						</ul>-->
				<!--					</li>-->
				<!--					<li>{{ $t('rtr_privacy.list57') }}</li>-->
				<!--					<li>{{ $t('rtr_privacy.list58') }}</li>-->
				<!--					<li>-->
				<!--						{{ $t('rtr_privacy.list59') }}-->
				<!--						<ul>-->
				<!--							<li>{{ $t('rtr_privacy.list60') }}</li>-->
				<!--							<li>{{ $t('rtr_privacy.list61') }}</li>-->
				<!--							<li>{{ $t('rtr_privacy.list62') }}</li>-->
				<!--						</ul>-->
				<!--					</li>-->
				<!--				</ul>-->
			</div>
		</div>
	</div>
</template>

<script>
import TncSidebar from '@/components/Menu/TncSidebar.vue';
import '@/assets/css/privacy.m.css';

export default {
	name: 'Privacy.m',
	mounted() {
		window.addEventListener('scroll', this.updateSidebar);
		window.addEventListener('resize', this.updateSidebar);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.updateSidebar);
		window.removeEventListener('resize', this.updateSidebar);
	},
	beforeRouteLeave(to, from, next) {
		window.document.documentElement.style.scrollBehavior = '';
		next();
	},
	components: { TncSidebar },
	data() {
		return {
			isContentMenuActive: false,
			menu_items: [
				{
					title: 'rtr_privacy.menu.text1',
					href: 'scrollpoint1',
					children: [
						{
							title: 'rtr_privacy.menu.text2',
							href: 'scrollpoint2',
						},
						{
							title: 'rtr_privacy.menu.text3',
							href: 'scrollpoint3',
						},
						{
							title: 'rtr_privacy.menu.text4',
							href: 'scrollpoint4',
						},
						{
							title: 'rtr_privacy.menu.text5',
							href: 'scrollpoint5',
						},
						{
							title: 'rtr_privacy.menu.text6',
							href: 'scrollpoint6',
						},
					],
				},
			],
		};
	},
	methods: {
		menuHandler() {
			this.isContentMenuActive = !this.isContentMenuActive;
		},
		updateSidebar() {
			let doc = document.documentElement;
			let top = (doc && doc.scrollTop) || document.body.scrollTop;
			const allHeaders = this.$refs.content.querySelectorAll(
				'h1, h2, h3, h4, h5, h6',
			);
			let last;
			for (let i = 0; i < allHeaders.length; i++) {
				let link = allHeaders[i];
				if (link.offsetTop > top) {
					if (!last) last = link;
					break;
				} else {
					last = link;
				}
			}
			if (last && last.id.length) this.setActive(last.id, false);
		},
		setActive(id, shouldScrollIntoView) {
			// console.log('aaa');
			const sidebar = this.$refs.sidebar;
			let previousActive = sidebar.querySelector('a.active');
			let currentActive =
				typeof id === 'string'
					? sidebar.querySelector('a[name=' + id + ']')
					: id;
			if (currentActive !== previousActive) {
				if (previousActive) previousActive.classList.remove('active');
				currentActive.classList.add('active');
				if (shouldScrollIntoView) {
					let currentPageOffset = 0;
					let currentActiveOffset =
						currentActive.offsetTop + currentActive.parentNode.clientHeight;
					let sidebarHeight = sidebar.clientHeight;
					let currentActiveIsInView =
						currentActive.offsetTop >= sidebar.scrollTop &&
						currentActiveOffset <= sidebar.scrollTop + sidebarHeight;
					let linkNotFurtherThanSidebarHeight =
						currentActiveOffset - currentPageOffset < sidebarHeight;
					let newScrollTop = currentActiveIsInView
						? sidebar.scrollTop
						: linkNotFurtherThanSidebarHeight
						? currentPageOffset
						: currentActiveOffset - sidebarHeight;
					sidebar.scrollTop = newScrollTop;
				}
			}
		},
		moveScroll(href) {
			const offsetTop = document.getElementById(href).offsetTop;
			window.scrollTo({ top: offsetTop });
		},
		handleSidebarClick(href) {
			this.menuHandler();
			window.document.documentElement.style.scrollBehavior = 'smooth';
			this.moveScroll(href);
		},
	},
};
</script>
<style scoped>
pre {
	white-space: pre-wrap;
}
</style>
